module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "div",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: "tipo-empresa",
    staticClass: "tipo-empresa-container"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seleccione el tipo de reclamación")]), _c('div', {
    staticClass: "select-box"
  }, _vm._l((_vm.tipos), function(o) {
    return _c('div', {
      staticClass: "option bd-color-empresa",
      class: {
        'bg-empresa': _vm.detalle.tipo === o.codigo
      },
      on: {
        "click": function($event) {
          _vm.seleccionarTipo(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  }))]), (_vm.detalle.tipo === 'queja') ? _c('div', {
    key: "queja-description",
    staticClass: "description-box message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('p', [_vm._v("Una queja es la disconformidad no relacionada a los productos o servicios; ")]), _c('p', [_vm._v("o, malestar o descontento respecto a la atención al público.")])])]) : _vm._e(), (_vm.detalle.tipo === 'reclamo') ? _c('div', {
    key: "reclamo-description",
    staticClass: "description-box message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('p', [_vm._v("Una reclamo es la disconformidad relacionada a los productos o servicios")])])]) : _vm._e(), _c('div', {
    key: "datos",
    staticClass: "datos-persona-natural"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" Detalle de reclamación")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detalle.descripcion),
      expression: "detalle.descripcion"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.detalle.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detalle, "descripcion", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" Pedido")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detalle.pedido),
      expression: "detalle.pedido"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.detalle.pedido)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detalle, "pedido", $event.target.value)
      }
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("4. Detalle de la reclamación y pedido del consumidor")]), _c('p', [_c('span', [_vm._v("Por favor detalle lo sucedido y lo que espera de nosotros para solucionarlo")])]), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-975780ac","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box-4-detalle-pedido-consumidor.vue
// module id = 83
// module chunks = 0